import { render, staticRenderFns } from "./BlackBoxLoader.vue?vue&type=template&id=38653c1e&scoped=true&"
import script from "./BlackBoxLoader.vue?vue&type=script&lang=js&"
export * from "./BlackBoxLoader.vue?vue&type=script&lang=js&"
import style0 from "./BlackBoxLoader.vue?vue&type=style&index=0&id=38653c1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38653c1e",
  null
  
)

export default component.exports